import request from '@/utils/request'

export function getPublicOverview(data) {
  return request({
    url: '/api/v1/admin/public/overview',
    method: 'post',
    mock: false,
    data,
  })
}

